import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { PatientInformationsModal } from './PatientInformationsModal.component'

const withUnmountHoc = withUnmountTransition(PatientInformationsModal)
export { withUnmountHoc as PatientInformationsModal }
